var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useContext, useEffect, useRef, useState } from 'react';
import { VideoCarouselContext } from '../VideoCarousel/VideoCarouselContext';
export const useVideoRef = ({ muteOnLoad, autoplay, videoIndex, preload, }) => {
    var _a, _b;
    const { muteCarousel, unMuteCarousel, isCarouselMuted, storeTime, carouselStartTimes, } = useContext(VideoCarouselContext);
    const ref = useRef();
    const [isLoadState, setIsLoadState] = useState(true);
    const [isPlaying, setIsPlaying] = useState(autoplay);
    const [isMuted, setIsMuted] = useState(muteOnLoad || isCarouselMuted ? true : false);
    let playErrorCount = 0;
    const play = () => __awaiter(void 0, void 0, void 0, function* () {
        var _c;
        if (!isPlaying) {
            yield ((_c = ref.current) === null || _c === void 0 ? void 0 : _c.play().then(() => {
                setIsLoadState(false);
                setIsPlaying(true);
            }).catch(() => {
                if (ref.current && playErrorCount === 0) {
                    ref.current.load();
                    ref.current.muted = true;
                    play();
                    playErrorCount++;
                }
                else {
                    setIsLoadState(false);
                    setIsPlaying(false);
                }
            }));
        }
    });
    useEffect(() => {
        if (ref.current && ref.current.muted !== isMuted) {
            ref.current.muted = isMuted;
        }
    }, [isMuted, ref]);
    const pause = () => {
        var _a, _b, _c;
        if (isPlaying && !((_a = ref === null || ref === void 0 ? void 0 : ref.current) === null || _a === void 0 ? void 0 : _a.paused)) {
            (_b = ref.current) === null || _b === void 0 ? void 0 : _b.pause();
            setIsPlaying(false);
            if (isLoadState) {
                setIsLoadState(false);
            }
            storeTime === null || storeTime === void 0 ? void 0 : storeTime({
                index: videoIndex,
                currentTime: (_c = ref === null || ref === void 0 ? void 0 : ref.current) === null || _c === void 0 ? void 0 : _c.currentTime,
            });
        }
    };
    const mute = () => {
        if (ref.current) {
            ref.current.muted = true;
            setIsMuted(true);
            muteCarousel === null || muteCarousel === void 0 ? void 0 : muteCarousel();
        }
    };
    const unMute = () => {
        if (ref.current) {
            ref.current.muted = false;
            setIsMuted(false);
            unMuteCarousel === null || unMuteCarousel === void 0 ? void 0 : unMuteCarousel();
        }
    };
    const setPlayState = (playstate) => {
        setIsPlaying(playstate);
    };
    useEffect(() => {
        var _a;
        if (ref.current && ((_a = ref.current) === null || _a === void 0 ? void 0 : _a.autoplay) !== autoplay) {
            if (!autoplay) {
                pause();
            }
            else if (autoplay && !isPlaying) {
                if (ref.current.paused) {
                    play();
                }
                else {
                    setPlayState(true);
                }
            }
            ref.current.autoplay = autoplay;
            ref.current.loop = autoplay;
            ref.current.muted = isMuted;
        }
    });
    useEffect(() => {
        if (isCarouselMuted !== undefined && isCarouselMuted !== isMuted) {
            if (isCarouselMuted) {
                mute();
            }
            else {
                unMute();
            }
        }
    });
    (_a = ref.current) === null || _a === void 0 ? void 0 : _a.addEventListener('ended', () => {
        if (ref.current && !ref.current.autoplay) {
            setIsLoadState(true);
            if (muteOnLoad) {
                setIsMuted(true);
            }
            if (ref.current) {
                ref.current.currentTime = 0;
            }
        }
    });
    const startTime = carouselStartTimes === null || carouselStartTimes === void 0 ? void 0 : carouselStartTimes[videoIndex];
    const readyState = (_b = ref.current) === null || _b === void 0 ? void 0 : _b.readyState;
    const [loading, setLoading] = useState(false);
    useEffect(() => {
        var _a;
        if (preload === 'auto' && readyState === 0 && !loading) {
            (_a = ref.current) === null || _a === void 0 ? void 0 : _a.load();
        }
    });
    if (ref.current) {
        ref.current.onloadeddata = () => {
            if (startTime && startTime > 0 && ref.current) {
                ref.current.currentTime = startTime;
            }
            setLoading(false);
        };
        ref.current.onloadstart = () => {
            setLoading(true);
        };
        ref.current.onabort = () => {
            var _a;
            (_a = ref.current) === null || _a === void 0 ? void 0 : _a.load();
        };
    }
    return {
        ref,
        isLoadState,
        play,
        pause,
        isPlaying,
        isMuted,
        mute,
        unMute,
        startTime,
        isLoading: loading,
    };
};
//# sourceMappingURL=useVideoRef.js.map